// import "./new.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { useState } from "react";
// import { nclassInputs } from "../../formSource";
// import { useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const classOptions = [
//   { value: "IX", label: "IX" },
//   { value: "X", label: "X" },
//   { value: "XI", label: "XI" },
//   { value: "XII", label: "XII" },
// ];

// const ClassNew = ({ title }) => {
//   // const [file, setFile] = useState("");
//   const navigate = useNavigate();
//   const [inputValues, setInputValues] = useState({});

//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const handleInputChange = (e) => {
//     console.log(e.target.name);
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log("inputValues", inputValues);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("name", inputValues.name);
//     formData.append("total_students", inputValues.total_students);
//     // formData.append("subjects_id", subjectValues);
//     // formData.append("logo", file); // Append the file to FormData

//     try {
//       // Send formData to the server using an HTTP request with multipart/form-data
//       const response = await fetch(`${serverUrl}/add_class`, {
//         method: "POST",
//         body: formData, // Use formData here with multipart/form-data
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }

//         // Clear all input data and roles when error occurs
//         setInputValues({});
//         // setSelectedUser([]);

//         // Force the component to rerender with the empty state
//         setTimeout(() => {}, 500); // Adding timeout to allow state change
//       } else {
//         toast.success("Class added successfully!");

//         // Clear form data after success
//         setInputValues({});
//         // setSelectedUser([]);

//         // Navigate to the users page after success
//         setTimeout(() => {
//           navigate("/class");
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const handleClassSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       name: selectedOption.value,
//     });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         file
//                                     }
//                                     alt=""
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {/* <div className="formInput">
//                                         <label htmlFor="file">
//                                             Image: <DriveFolderUploadOutlinedIcon className="icon" />
//                                         </label>
//                                         <input
//                                             type="file"
//                                             id="file"
//                                             onChange={(e) => setFile(e.target.files[0])}
//                                             style={{ display: "none" }}
//                                         />
//                                     </div> */}
//                   {nclassInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "name" ? (
//                         <Select
//                           options={classOptions}
//                           name={input.fieldName}
//                           onChange={handleClassSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default ClassNew;



import React, { useState } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { nclassInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const classOptions = [
  { value: "IX", label: "IX" },
  { value: "X", label: "X" },
  { value: "XI", label: "XI" },
  { value: "XII", label: "XII" },
];

const ClassNew = ({ title }) => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({});
  const token = localStorage.getItem("token");

  const redirectToLogin = () => {
    alert("Please Login first then you can access this page...");
    window.location.href = "/";
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleClassSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      name: selectedOption.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("name", inputValues.name);
    formData.append("total_students", inputValues.total_students);

    try {
      const response = await fetch(`${serverUrl}/add_class`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Class added successfully!");
        setInputValues({});
        setTimeout(() => {
          navigate("/class");
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {nclassInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "name" ? (
                              <Select
                                options={classOptions}
                                onChange={handleClassSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/class")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Create Class
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default ClassNew;